import { z } from 'zod';
import { BOM_ITEM_GROUP_MEMBER_FLOOR, MAX_BOM_ITEM_GROUP_MEMBERS, MAX_BOM_ITEM_GROUP_MEMBERS_MESSAGE, } from './constraints.js';
import { bomItemGroupNameSchema, bomItemGroupPromptSchema } from './item-group-form.js';
import { bomItemGroupMemberSchema, isRawGoodGroupMember, RAW_GOOD_ONLY_GROUP_MEMBER_MESSAGE, } from './item-group-member.js';
const GROUP_MEMBER_SCHEMA = bomItemGroupMemberSchema
    .extend({ groupDefault: z.boolean() })
    .refine(isRawGoodGroupMember, { message: RAW_GOOD_ONLY_GROUP_MEMBER_MESSAGE, path: ['typeId'] });
// One Option Group nested inside CreateBomInput.itemGroups — mirrors addBomItemGroupWithItemsInputSchema minus bomId.
export const createBomItemGroupInputSchema = z
    .object({
    name: bomItemGroupNameSchema,
    prompt: bomItemGroupPromptSchema,
    items: z
        .array(GROUP_MEMBER_SCHEMA)
        // No group exists yet at create time, so "delete the group instead" (BOM_ITEM_GROUP_MEMBER_FLOOR_MESSAGE) doesn't apply here.
        .min(BOM_ITEM_GROUP_MEMBER_FLOOR, `An option group needs at least ${BOM_ITEM_GROUP_MEMBER_FLOOR} members.`)
        .max(MAX_BOM_ITEM_GROUP_MEMBERS, MAX_BOM_ITEM_GROUP_MEMBERS_MESSAGE),
})
    .superRefine((value, context) => {
    const defaultCount = value.items.filter((item) => item.groupDefault).length;
    if (defaultCount !== 1) {
        context.addIssue({
            code: 'custom',
            message: 'Exactly one item must be the group default.',
            path: ['items'],
        });
    }
});
//# sourceMappingURL=create-item-group-input.js.map